import { render, staticRenderFns } from "./cleanRecord.vue?vue&type=template&id=3d4b70a9&scoped=true&"
import script from "./cleanRecord.vue?vue&type=script&lang=js&"
export * from "./cleanRecord.vue?vue&type=script&lang=js&"
import style0 from "./cleanRecord.vue?vue&type=style&index=0&id=3d4b70a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b70a9",
  null
  
)

export default component.exports